import { colors, ColorValueDefinition } from '@/utils/helpers'

export const acwrColorsDefinition: ColorValueDefinition[] = [
  {
    max: 0.6,
    color: colors[0]
  },
  {
    max: 0.8,
    color: colors[3]
  },
  {
    max: 1.3,
    color: colors[9]
  },
  {
    max: 1.5,
    color: colors[3]
  },
  {
    max: 50,
    color: colors[0]
  }
]
